
import { defineComponent, PropType, ref } from 'vue'
import QForm from 'quasar/src/components/form/QForm.js';import useDialogPluginComponent from 'quasar/src/composables/use-dialog-plugin-component.js';
import { useFormModule } from '@/modules/_shared/forms'
import { AgreementScheduledPrice, useAgreementModule } from '@/modules/agreements'
import FormFieldScheduledPrices from '@/components/_shared/form-fields/scheduled-prices.vue'
import {
    CreateAgreementScheduledPriceRequest,
    DeleteAgreementScheduledPriceRequest,
    UpdateAgreementScheduledPriceRequest
} from '@/modules/agreements/api'

export default defineComponent({
    name: 'agreement-edit-scheduled-prices-dialog',
    components: {
        FormFieldScheduledPrices
    },
    props: {
        agreementScheduledPrices: {
            type: Array as PropType<AgreementScheduledPrice[]>,
            required: true
        },
        id: {
            type: String,
            required: true
        },
        invoicingPeriod: {
            type: Number,
            required: true
        },
        updateCallback: {
            type: Function as PropType<(t: AgreementScheduledPrice[]) => void>,
            required: true
        }
    },
    setup (props) {
        const { dialogRef, onDialogHide, onDialogOK, onDialogCancel } = useDialogPluginComponent()
        const { submitForm, createOnSuccess } = useFormModule()
        const { createAgreementScheduledPrice, updateAgreementScheduledPrice, deleteAgreementScheduledPrice } = useAgreementModule()

        const form = ref<QForm>()
        const scheduledPricesModel = ref<AgreementScheduledPrice[]>(props.agreementScheduledPrices)

        const onSubmit = () => submitForm(
            form.value,
            async () => true,
            createOnSuccess('Agreement scheduled prices changed')
        ).then(() => {
            onDialogOK()
            props.updateCallback(scheduledPricesModel.value)
        })

        const createPricesCallback = async (prices: AgreementScheduledPrice[]) => {
            for (const price of prices) {
                const request = {
                    agreementId: props.id,
                    validFrom: price.validFrom,
                    price: price.price
                } as CreateAgreementScheduledPriceRequest
                await createAgreementScheduledPrice(props.id, request)
            }
        }

        const updatePricesCallback = async (prices: AgreementScheduledPrice[]) => {
            for (const price of prices) {
                const request = {
                    id: price.id,
                    agreementId: props.id,
                    validFrom: price.validFrom,
                    price: price.price
                } as UpdateAgreementScheduledPriceRequest
                await updateAgreementScheduledPrice(props.id, request)
            }
        }

        const removePricesCallback = async (prices: AgreementScheduledPrice[]) => {
            for (const price of prices) {
                const request = {
                    id: price.id,
                    agreementId: props.id
                } as DeleteAgreementScheduledPriceRequest
                await deleteAgreementScheduledPrice(props.id, request)
            }
        }

        return {
            dialogRef,
            onDialogHide,
            onCancelClick: onDialogCancel,
            scheduledPricesModel,
            onSubmit,
            createPricesCallback,
            updatePricesCallback,
            removePricesCallback,
            form
        }
    }
})
